module.exports = __webpack_public_path__ + "static/media/headerLogo.18d9ba5d.png";